<template>
  <div class="card-container">
    <div class="c-header-container">
      <div class="c-header">
        NEW MEMBERS
      </div>
      <div class="sac__font-14 f-white">
        {{ date }}
      </div>
    </div>
    <div class="c-number-container">
      <img
        v-if="loading && customersCount.lastMonthMembersCount < 1"
        src="@shared/assets/img/general/loading-white.svg"
        class="loading"
        alt="loading"
      >
      <div
        v-else-if="customersCount.lastMonthMembersCount === 0"
        class="sac__font-14 f-white med"
      >
        No new member
      </div>
      <div
        v-else
        class="c-number"
      >
        {{ customersCount.lastMonthMembersCount }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import customerMixin from '@shared/mixins/customerMixin';

const today = moment();
const firstDay = moment().startOf('month');
const date = `${firstDay.format('MMM D')} - ${today.format('D, YYYY')}`;

export default {
  name: 'NewOnboardSystem',
  mixins: [customerMixin],
  data() {
    return {
      count: 0,
      countLabel: '',
      percent: 0,
      date,
    };
  },
};
</script>
